module.exports = __webpack_public_path__ + "img/logo_vip_card@2x.13dbb4ad.png";